module.exports = __webpack_public_path__ + "static/media/03n.8d2c0b2d.svg";